
import * as React from "react";
import { Redirect } from "react-router-dom";
import Router from "../defaults/Router.tsx";
import requestPilets from "../../../../../src/requestPilets.ts";
import plugins from "../../../../../src/plugins.ts";
import setup from "../../../../../src/setup.tsx";

function replaceAllParams(path, params) {
  Object.keys(params).forEach(key => {
    path = path.split(':' + key).join(params[key]);
  });

  return path;
}

const NotFoundPage = React.lazy(() => import("../../../../../src/NotFoundPage.tsx"));
const version = "1.2.0";
const updated = "Sat Aug 01 2026";
const publicUrl = "/";
const pages = {
  "/": React.lazy(() => import("../../../../../src/HomePage.tsx")), "/imprint": React.lazy(() => import("../../../../../src/ImprintPage.tsx"))
};
const layouts = {
  "default": React.lazy(() => import("../defaults/Layout.tsx")), "blog": React.lazy(() => import("../../../../../src/Blog.tsx"))
};

export { Router, NotFoundPage, requestPilets, pages, plugins, setup, version, updated, publicUrl, layouts };
